import axios from '../requester';
import { API } from '../constants/api-urls';

export function createToken({ label }) {
  return axios.post(`${API.API_TOKENS_PATH}/generate`, { label });
}

export function revokeToken({ id }) {
  return axios.post(`${API.API_TOKENS_PATH}/revoke/${id}`);
}

export function getTokens() {
  return axios.get(`${API.API_TOKENS_PATH}`);
}
